import React, {Fragment} from 'react'
import yn from 'yn'
import moment from 'moment'

import BkFlowRestaurantsConfirmationCards from '../../restaurants/BkFlowRestaurantsConfirmationCards'
import BkFlowConfirmationRoomCard from '../elements/default/BkFlowConfirmationRoomCard'
import BkFlowPolicies from '../../policies/BkFlowPolicies'
import BkFlowConfirmationCta from '../elements/default/BkFlowConfirmationCta'
import BkFlowPreCheckinModal from '../elements/default/BkFlowPreCheckInModal'

import formatPrice from '../../../utilities/currency/formatPrice'

// import facebookIcon from '../../../assets/icons/facebook.svg'
// import twitterIcon from '../../../assets/icons/twitter.svg'
// import emailIcon from '../../../assets/icons/email.svg'

if (process.env.REACT_APP_COMPONENT_CONFIRMATION_LAYOUT === 'default') {
	require('../../../styles/css/components/confirmation/default/bk-flow-confirmation-default.css')
}

const BkFlowConfirmationDefault = props => {
	const {
		activeCurrencyData,
		// activeHotelEmail,
		closePreCheckInModal,
		currencySymbol,
		handlePreCheckinPanel,
		hotelLabels,
		isPreCheckDisabled,
		modifyPreCheckin,
		preCheckGroupExpanded,
		preCheckinModalVisible,
		renderArrival,
		renderCurrencyCode,
		renderDeparture,
		renderEnhancementsTotal,
		renderFeeTotal,
		renderGuests,
		renderItineraryId,
		renderPropertyLink,
		renderPropertyName,
		renderSubTotal,
		renderTaxesFeesTotal,
		renderTaxTotal,
		renderTotal,
		reservationError,
		reservationLoading,
		reservations,
		// socialEmailContent,
		// socialTwitterContent,
	} = props

	const renderReservationCards = () => {
		// Begin Render Card Layouts
		if (reservations) {
			let reservation

			// Create V. modify data
			if (reservations.hotelResModifies) {
				reservation = reservations.hotelResModifies
			} else {
				reservation = reservations
			}

			if (reservation) {
				return Object.keys(reservation).map(reservationKey => {
					return (
						<BkFlowConfirmationRoomCard
							key={ reservation[reservationKey].uniqueId.id }
							reservationKey={ reservationKey }
							openPreCheckInModal= { this.openPreCheckInModal }
						/>
					)
				})
			}
		}
	}

	return (
		<div className="bk-flow-confirmation__details default">
			{/* <div className="bk-flow-confirmation__header">
				<h2>{ hotelLabels.thankYou ? hotelLabels.thankYou : 'Thank You' }</h2>

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_SOCIAL_LINKS) &&
					<div className="bk-flow-confirmation__social row center-xs middle-xs">
						<span className="h6">{ hotelLabels.shareYourExcitement ? hotelLabels.shareYourExcitement : 'Share Your Excitement' }:</span>

						{ renderPropertyLink &&
							<Fragment>
								<span
									className="bk-flow-confirmation__social-icon icon--facebook"
									onClick={() => window.open( 'http://www.facebook.com/sharer.php?u='+encodeURIComponent( window.location.origin + renderPropertyLink ),'sharer','toolbar=0, status=0, width=626, height=436' )}
								>
									<img
										src={facebookIcon}
										className="u-social-icon"
										alt="Share on Facbook"
									/>
								</span>

								<span
									className="bk-flow-confirmation__social-icon icon--twitter"
									onClick={() => window.open( 'http://twitter.com/share?text=' + socialTwitterContent + '.&url=' + encodeURIComponent( window.location.origin + renderPropertyLink ),'sharer','toolbar=0, status=0, width=600, height=400' )}
								>
									<img
										src={twitterIcon}
										className="u-social-icon"
										alt="Share on Twitter"
									/>
								</span>
							</Fragment>
						}

						{ activeHotelEmail &&
							<a
								className="bk-flow-confirmation__social-icon icon--email"
								href={ 'mailto:?subject=' + socialEmailContent + '&body=Check out ' + window.location.origin + renderPropertyLink }
							>
								<img
									src={emailIcon}
									className="u-social-icon"
									alt="Share by Email"
								/>
							</a>
						}
					</div>
				}
			</div> */}

			<div className="bk-flow-confirmation__content">
				<div className="bk-flow-confirmation__itinerary row start-xs">
					<h3 className="bk-flow-confirmation__itinerary-heading">
						{ hotelLabels.yourStayDetails ? hotelLabels.yourStayDetails : 'Your Stay Details' }
					</h3>
					<div className="bk-flow-confirmation__itinerary-details">
						<div className="bk-flow-confirmation__itinerary-details-row">
							<h4>
								{ renderPropertyName }

								<span className="bk-flow-confirmation__itinerary-details-property-link">
									{ renderPropertyLink && ' | ' }
									{ renderPropertyLink &&
										<button
											className="btn btn-text-only basic-link"
											onClick={() => window.open( renderPropertyLink )}
										>
											{ hotelLabels.exploreHotel ? hotelLabels.exploreHotel : 'Explore Hotel' }
										</button>
									}
								</span>
							</h4>

							{ hotelLabels.confirmationEmailMessage && <p>{ hotelLabels.confirmationEmailMessage }</p> }
						</div>

						{ yn(process.env.REACT_APP_COMPONENT_ENABLE_ITINERARY_NUMBER) &&
							<div className="bk-flow-confirmation__itinerary-details-row row u-remove-margin">
								<span className="">{ hotelLabels.itineraryNumber }:&nbsp;</span>
								{ renderItineraryId ?
									<span className="bk-flow-confirmation__itinerary-details-val">{ renderItineraryId }</span>
								:
									<span className="bk-flow-confirmation__itinerary-details-val">--</span>
								}
							</div>
						}

						<div className="bk-flow-confirmation__itinerary-details-row row u-remove-margin">
							<span className="">{ hotelLabels.arrivalDate }:&nbsp;</span>
							{ renderArrival ?
								<span className="bk-flow-confirmation__itinerary-details-val">{moment(renderArrival).format('dddd, MMMM D, YYYY')}</span>
							:
								<span className="bk-flow-confirmation__itinerary-details-val">--</span>
							}
						</div>

						<div className="bk-flow-confirmation__itinerary-details-row row u-remove-margin">
							<span className="">{ hotelLabels.departureDate }:&nbsp;</span>
							{ renderDeparture ?
								<span className="bk-flow-confirmation__itinerary-details-val">{moment(renderDeparture).format('dddd, MMMM D, YYYY')}</span>
							:
								<span className="bk-flow-confirmation__itinerary-details-val">--</span>
							}
						</div>

						<div className="bk-flow-confirmation__itinerary-details-row row u-remove-margin">
							<span className="">{ hotelLabels.guests }:&nbsp;</span>
							{ renderGuests ?
								renderGuests
							:
								<span className="bk-flow-confirmation__itinerary-details-val">--</span>
							}
						</div>
					</div>

					<div className="bk-flow-confirmation__itinerary-pricing">
						<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
							<div className="u-price-line__row">
								<span className="">{ hotelLabels.subtotal }:&nbsp;</span>
								{ renderSubTotal && yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) ?
									<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderSubTotal * activeCurrencyData.exchangeRate, 2) }{ renderCurrencyCode }</span>
								: renderSubTotal ?
									<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderSubTotal, 2) }{ renderCurrencyCode }</span>
								:
									<span className="bk-flow-confirmation__itinerary-details-val">--</span>
								}
							</div>
						</div>

						{ yn(process.env.REACT_APP_COMPONENT_ENABLE_RATE_COMBINED_TAXES_FEES) ?
							<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
								<div className="u-price-line__row">
									{hotelLabels.taxesAndFees
										? (
											<span className="">{ hotelLabels.taxesAndFees || 'Taxes & Fees' }:&nbsp;</span>
										) : (
											<span className="">{ hotelLabels.taxes ? hotelLabels.taxes : 'Taxes' } &amp; { hotelLabels.fees ? hotelLabels.fees : 'Fees' }:&nbsp;</span>
										)}
									{ renderTaxesFeesTotal && yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) ?
										<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTaxesFeesTotal * activeCurrencyData.exchangeRate, 2) }{ renderCurrencyCode }</span>
									: renderTaxesFeesTotal ?
										<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTaxesFeesTotal, 2) }{ renderCurrencyCode }</span>
									:
										<span className="bk-flow-confirmation__itinerary-details-val">--</span>
									}
								</div>
							</div>
						:
							<Fragment>
								<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
									<div className="u-price-line__row">
										<span className="">{ hotelLabels.taxes ? hotelLabels.taxes : 'Taxes' }:&nbsp;</span>
										{ renderTaxTotal && yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) ?
											<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTaxTotal * activeCurrencyData.exchangeRate, 2) }{ renderCurrencyCode }</span>
										: renderTaxTotal ?
											<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTaxTotal, 2) }{ renderCurrencyCode }</span>
										:
											<span className="bk-flow-confirmation__itinerary-details-val">--</span>
										}
									</div>
								</div>
								<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
									<div className="u-price-line__row">
										<span className="">{ hotelLabels.fees ? hotelLabels.fees : 'Fees' }:&nbsp;</span>
										{ renderFeeTotal && yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) ?
											<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderFeeTotal * activeCurrencyData.exchangeRate, 2) }{ renderCurrencyCode }</span>
										: renderFeeTotal ?
											<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTaxTotal, 2) }{ renderCurrencyCode }</span>
										:
											<span className="bk-flow-confirmation__itinerary-details-val">--</span>
										}
									</div>
								</div>
							</Fragment>
						}

						<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
							<div className="u-price-line__row u-price-line__row-total">
								<span className="">{ hotelLabels.total ? hotelLabels.total : 'Total' }:&nbsp;</span>
								{ renderTotal && yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) ?
									<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTotal * activeCurrencyData.exchangeRate, 2) }{ renderCurrencyCode }</span>
								: renderTotal ?
									<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + formatPrice(renderTotal, 2) }{ renderCurrencyCode }</span>
								:
									<span className="bk-flow-confirmation__itinerary-details-val">--</span>
								}
							</div>
						</div>

						{ yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
							<div className="bk-flow-confirmation__itinerary-pricing-row u-remove-margin u-price-line">
								<div className="u-price-line__row">
									<span className="">{ hotelLabels.formattedAddons ? hotelLabels.formattedAddons : 'Add-Ons' }:&nbsp;</span>
									<span className="bk-flow-confirmation__itinerary-details-val">{ currencySymbol + renderEnhancementsTotal }</span>
								</div>
							</div>
						}

						{ reservations.warnings &&
							reservations.warnings[0].type === 3 &&
							reservations.warnings[0].shortText &&
								<p className="u-font-error">{ reservations.warnings[0].shortText }</p>
						}

						{yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
							<p className="bk-flow-confirmation__itinerary-disclaimer u-font-small">
								{hotelLabels.additionalChargesMessage ?
									hotelLabels.additionalChargesMessage
									:
									'Each addition requires a little customization. A team member will reach out to customize your additional experiences. You will not be charged for additions prior to arrival.'
								}
							</p>
						}
					</div>
				</div>

				<div className="bk-flow-confirmation__room-cards">
					{ renderReservationCards() }
				</div>

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS) && <BkFlowRestaurantsConfirmationCards /> }
			</div>

			{ yn(process.env.REACT_APP_COMPONENT_CONFIRMATION_PROPERTY_POLICIES) ||
				yn(process.env.REACT_APP_COMPONENT_CONFIRMATION_CTAS) ?
				<div className="bk-flow-confirmation__footer">
					{ yn(process.env.REACT_APP_COMPONENT_CONFIRMATION_PROPERTY_POLICIES) &&
						<BkFlowPolicies />
					}

					{ yn(process.env.REACT_APP_COMPONENT_CONFIRMATION_CTAS) &&
						<BkFlowConfirmationCta />
					}
				</div>
			:
				null
			}

			{ yn(process.env.REACT_APP_COMPONENT_ENABLE_PRE_CHECK_IN) &&
				<BkFlowPreCheckinModal
					closePreCheckInModal={closePreCheckInModal}
					handlePreCheckinPanel={handlePreCheckinPanel}
					hotelLabels={hotelLabels}
					isPreCheckDisabled={isPreCheckDisabled}
					preCheckGroupExpanded={preCheckGroupExpanded}
					preCheckinModalVisible={preCheckinModalVisible}
					modifyPreCheckin={modifyPreCheckin}
					reservations={reservations}
					reservationError={reservationError}
					reservationLoading={reservationLoading}
				/>
			}
		</div>
	)
}

export default BkFlowConfirmationDefault



// WEBPACK FOOTER //
// ./src/components/confirmation/layouts/BkFlowConfirmationDefault.js